<style scoped>
    .expand-row{
        margin-bottom: 16px;
    }
</style>
<template>
    <div>
        <Row class="expand-row">
            <Col span="12">
                <span class="expand-key">跟踪号: </span>
                <span class="expand-value">{{ row.TrackingNumber }}</span>
            </Col>
            <Col span="6">
                <span class="expand-key">目的国家: </span>
                <span class="expand-value">{{ row.ToCountryName }}</span>
            </Col>
            <Col span="6">
                <span class="expand-key">渠道代码: </span>
                <span class="expand-value">{{ row.ChannelCode }}</span>
            </Col>
        </Row>
        <Row>
            <Col span="20">
                <Steps :current="0" direction="vertical" v-for="(item, index) in row.NodeList">
                    <Step v-if="index===0" icon="ios-send" :title="item.Time" :content="item.NodeTrack"></Step>
                    <Step  v-else  icon="ios-send-outline" :title="item.Time" :content="item.NodeTrack"></Step>
                </Steps>
            </Col>
        </Row>
    </div>
</template>
<script>
    export default {
        props: {
            row: Object
        }
    };
</script>